import React from 'react';
import Card from '../Card';
import UserPlayer from '../../entities/players/UserPlayer';
import CardTypes from '../../constants/CardTypes';
import Constants from '../../constants/Constants';

export default class VirusCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = () => {
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_VIRUS_CARD);

        let nextPlayerEntity = this.gameCtx.gameSeqHandler.getNextTurnEntity();

        if (nextPlayerEntity instanceof UserPlayer) {

            nextPlayerEntity.subscribePlayMethod(
                this.userPlayeresponseMove,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
        else {
            nextPlayerEntity.subscribePlayMethod(
                this.computerPlayeresponseMove,
                Constants.FLAGS_SINGLE_TIME_USE,
                Constants.FLAGS_REPLACE_METHOD
            );
        }
    }

    // COMPUTER PLAYER MOVES

    computerPlayeresponseMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let val = cEntity.hasCardFromType(CardTypes.ONION_GARLIC_CARD);

        if (val) { // Notice: If computerPlayer has a protection card, it will always use it
            await this.computerPlayerProtectiveMove(val);
        }
        else {
            await this.computerPlayerIsAttacked();
        }
    }

    computerPlayerIsAttacked = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        await cEntity.resetCards();
    }

    computerPlayerProtectiveMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        cEntity.includeType = { viType: [CardTypes.ONION_GARLIC_CARD], cb: null };

        // this.gameCtx.soundRepository.playSoundByName(Constants.PROTECT_CARD);

        cEntity.chooseRandCard(false, true);

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);

        this.gameCtx.soundRepository.pauseSoundByName(Constants.SOUND_VIRUS_CARD);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_PROTECTION_CARD);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);

        await cEntity.getCardsFromNewPile(1);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL);
    }

    // USER PLAYER MOVES

    userPlayeresponseMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        let val = cEntity.hasCardFromType(CardTypes.ONION_GARLIC_CARD);

        if (val) {
            await this.userPlayerProtectiveMove();
        }
        else {
            await this.informAttack();
            await cEntity.resetCards();
        }
    }

    informAttack = async () => {
        let text = <div className="popup-text interval-popup-text increasd-text">"הותקפת בקלף "וירוס!<br />אין ברשותך קלף הגנה "שום-בצל", התכונן לכאב בטן!</div>

        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.addPopupWithInterval(text);
        await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
    }

    userPlayerProtectiveMove = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();

        let text = <div className="popup-text">"הותקפת בקלף "וירוס!<br />"האם תרצה להשתמש בקלף הגנה "שום-בצל?</div>

        let popupRes = await cEntity.addPopupWithEvent(text);

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);

        if (popupRes) {
            await this.enableClickingProtectionCard();
        }
        else {

            await cEntity.resetCards();
        }
    }

    enableClickingProtectionCard = async () => {
        let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
        cEntity.addBubbleOnBottomPlayer("זרוק קלף שום-בצל", Constants.ELEMENT_MY_PLAYER_THROW_ONION_GARLIC_CARD);
        cEntity.setFinalUserEvent();

        cEntity.includeType = {
            viType: [CardTypes.ONION_GARLIC_CARD], cb: async () => {
                let text = <div className="popup-text interval-popup-text">עליך לבחור קלף הגנה<br />"שום-בצל"!</div>

                let cEntity = this.gameCtx.gameSeqHandler.getCurrentEntity();
                cEntity.addPopupWithInterval(text);
                await this.gameCtx.waitFor(Constants.INTERVAL_BEFORE_REMOVE_POPUP);

                this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_CARD_POPUP);
            }
        };

        cEntity.subscribeUserEventToCards(
            (cardObj) => cEntity.handleChooseCardEvent(cardObj, false, true),
            Constants.FLAGS_MULTIPLE_TIME_USE);

        await cEntity.waitForEvent();

        this.gameCtx.elementsHandler.removeElement(Constants.ELEMENT_MY_PLAYER_THROW_ONION_GARLIC_CARD);

        if (!cEntity.chosenCard) { // If user didn't throw protection card --> Throw automatically protection card
            cEntity.chooseRandCard(false, true);
        }

        await this.gameCtx.moveCard(cEntity.entityIndex, Constants.USED_PILE_INDEX, cEntity.chosenCard, true, true);
        
        this.gameCtx.soundRepository.pauseSoundByName(Constants.SOUND_VIRUS_CARD);
        this.gameCtx.soundRepository.playSoundByName(Constants.SOUND_PROTECTION_CARD);
        
        await cEntity.getCardsFromNewPile(1);

        await this.gameCtx.waitFor(Constants.INTERVAL_CARD_MOVE_FULL) // for debugging
        
        cEntity.resolvePlayerFinal(0);

        //You should manually return the promise that resolves the last move..
        return cEntity.userEventComplete;
    }
}